<template>
  <div id="ag-grid-demo">
    <vs-popup class="holamundo" title="New Room" :active.sync="popupActivo">
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/3 w-full topPad">
          <span class="popup_lbl inputStyles">Room No</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <vs-input
            class="inputx w-full"
            v-validate="'required|max:35'"
            name="RoomNo"
            v-model="form.roomNo"
          />
          <span class="text-danger text-sm" v-show="errors.has('RoomNo')">{{
            errors.first("RoomNo")
          }}</span>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full topPad">
          <span class="popup_lbl inputStyles">Description</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <vs-input
            class="inputx w-full"
            v-validate="'max:100'"
            name="Description"
            v-model="form.description"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('Description')"
            >{{ errors.first("Description") }}</span
          >
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full topPad">
          <span class="popup_lbl inputStyles">Room Rate</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <vs-input
            class="inputx w-full"
            type="number"
            v-validate="'required|decimal:2'"
            name="RoomRate"
            v-model="form.rate"
          />
          <span class="text-danger text-sm" v-show="errors.has('RoomRate')">
            {{ errors.first("RoomRate") }}
          </span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full topPad">
          <span class="popup_lbl inputStyles">Category</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <select
            v-model="form.categoryId"
            name="Category"
            v-validate="'required'"
            class="vs-select--input myselect"
            style="height: 36px"
          >
            <option
              class="vs-component"
              v-for="(item, index) in roomCategory"
              v-bind:key="index"
              :value="item.id"
            >
              {{ item.name }}
            </option>
          </select>
          <span class="text-danger text-sm" v-show="errors.has('Category')">{{
            errors.first("Category")
          }}</span>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full topPad">
          <span class="popup_lbl inputStyles">Active</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <vs-checkbox v-model="form.activeBool"> Active </vs-checkbox>
        </div>
      </div>
      <div class="vx-row mb-4 popup_btn" style="margin-top: 25px">
        <vs-button
          color="primary"
          type="border"
          style="margin-right: 15px"
          @click="saveRoomMaster()"
          id="button-with-loading"
          class="float-center vs-con-loading__container"
          >Save</vs-button
        >
        <vs-button
          color="primary"
          type="border"
          style="margin-left: 5px"
          @click="clearFields()"
          >Clear</vs-button
        >
      </div>
    </vs-popup>
    <vx-card>
      <div class="vx-row card-header-row">
        <div>
          <vs-button color="success" type="border" @click="openForm">
            New
          </vs-button>
        </div>

        <div>
          <feather-icon
            icon="XIcon"
            class="custom-class"
            style="width: 20px; height: 20px; color: #009696; cursor: pointer"
            title="Close"
            @click="exit"
          />
        </div>
      </div>

      <vue-good-table
        mode="remote"
        :rows="contacts"
        :columns="vgColumns"
        :totalRows="totalRecords"
        :pagination-options="{ enabled: true}"
        :sort-options="{ enabled: false }"
        :isLoading.sync="isLoading"
        @on-page-change="onPageChange"
        @on-column-filter="onColumnFilter"
        @on-row-dblclick="onRowDoubleClick"
        styleClass="vgt-table condensed"
      />
    </vx-card>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      popupActivo: false,
      roomCategory: [{ id: "", name: "Select" }],
      form: {
        roomNo: "",
        description: "",
        categoryId: "",
        roomId: "",
        rate: null,
        activeBool: true,
      },

      vgColumns: [
        {
          label: "ROOM NO",
          field: "roomNo",
          filterOptions: { enabled: true },
        },
        {
          label: "CATEGORY NAME",
          field: "categoryName",
          filterOptions: { enabled: true },
        },
        {
          label: "DESCRIPTION",
          field: "description",
          filterOptions: { enabled: true },
        },
        {
          label: "RATE",
          field: "rate",
          type: "number",
          filterOptions: { enabled: true },
        },
        {
          label: "ACTIVE",
          field: "active",
          formatFn: (val) => (val === "Y" ? "Yes" : "No"),
        },
      ],

      serverParams: {
        companyId: this.$session.get("companyId"),
        filter: {},
        currentPage: 1,
        limit: 10,
      },

      contacts: [],
      totalRecords: 0,
      isLoading: false,
    };
  },

  mounted() {
    this.loadRooms();
    this.getRoomCategory();
  },
  methods: {
    loadRooms() {
      this.isLoading = true;

      this.$http
        .post("getroomMasterDashboard", JSON.stringify(this.serverParams), {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          this.contacts = response.data.data;
          this.totalRecords = response.data.recordsTotal;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onPageChange(params) {
      this.serverParams.currentPage = params.currentPage;
      this.loadRooms();
    },
    onColumnFilter(params) {
      const f = params.columnFilters;
      let filterObj = {};

      if (f.roomNo) {
        filterObj.roomNo = {
          filter: f.roomNo,
          type: "contains",
        };
      }

      if (f.categoryName) {
        filterObj.categoryName = {
          filter: f.categoryName,
          type: "contains",
        };
      }

      if (f.description) {
        filterObj.description = {
          filter: f.description,
          type: "contains",
        };
      }

      if (f.rate) {
        filterObj.rate = {
          filter: f.rate,
          type: "equals",
        };
      }

      if (f.active) {
        filterObj.active = {
          filter: f.active,
          type: "equals",
        };
      }

      this.serverParams.filter = filterObj;
      this.loadRooms();
    },
    openForm() {
      this.clearFields();
      this.errors.clear();
      this.popupActivo = true;
    },
    onRowDoubleClick(params) {
      const row = params.row;

      this.form.roomNo = row.roomNo;
      this.form.description = row.description;
      this.form.categoryId = row.categoryId;
      this.form.roomId = row.roomId;
      this.form.rate = row.rate;
      this.form.activeBool = row.active === "Y";

      this.popupActivo = true;
    },
    exit() {
      this.$router.push("/Master");
    },

    saveRoomMaster() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          var request = {
            companyId: this.$session.get("companyId"),
            data: {
              roomId: this.form.roomId,
              roomNo: this.form.roomNo,
              description: this.form.description,
              categoryId: this.form.categoryId,
              rate: this.form.rate,
              active: this.form.activeBool ? "Y" : "N",
            },
          };
          this.buttonLoading();
          this.$http
            .post("saveRoomMaster", JSON.stringify(request), {
              headers: {
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              this.loadRooms();
              this.popupActivo = false;
              this.$vs.loading.close("#button-with-loading > .con-vs-loading");
              document.getElementById("button-with-loading").disabled = false;
              this.$vs.notify({
                title: "Successfully Saved",
                color: "success",
                iconPack: "feather",
                icon: "icon-check",
                position: "top-center",
              });
            })
            .catch((error) => {
              this.$vs.notify({
                title: "Error Occured While Saving",
                color: "danger",
                iconPack: "feather",
                icon: "icon-check",
                position: "top-center",
              });
            });
        }
      });
    },
    getRoomCategory() {
      var request = {
        companyId: this.$session.get("companyId"),
      };
      this.$http
        .post("getRoomCategory", JSON.stringify(request), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          response.data.data.forEach((element) => {
            this.roomCategory.push(element);
          });
        });
    },
    clearFields() {
      this.form = {
        roomNo: "",
        description: "",
        categoryId: "",
        roomId: "",
        rate: null,
        activeBool: true,
      };
    },
    buttonLoading() {
      document.getElementById("button-with-loading").disabled = true;
      this.$vs.loading({
        background: "primary",
        color: "#fff",
        container: "#button-with-loading",
        scale: 0.45,
      });
    },
  },
};
</script>

<style scoped>
.popup_lbl {
  padding-left: 10%;
}

.popup_btn {
  margin-left: 100px;
  padding-left: 98px;
}
.inputStyles {
  font-size: 11.8px;
  font-weight: 600;
}
.topPad {
  padding-top: 7px;
}
.card-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
}
.vgt-table thead th {
  background: white;
}

.vgt-wrap__footer {
  background: white;
}

table.vgt-table {
  font-size: 12px;
  border: none;
}

.vgt-right-align {
  text-align: left;
}

.vgt-table.condensed tr {
  height: 56px;
}

.vgt-table.condensed td {
  padding-top: 19px;
}

.vgt-input {
  border: none;
}

.vgt-wrap__footer {
  border: none;
}

.footer__row-count__label,
.footer__row-count__select {
  display: none !important;
}


</style>
